import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import { useAuthStore } from '@/stores/auth.js'

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: () => ({ top: 0 }),
  routes: [
    // 메인은 2026-09-25 에 바뀐 퍼블리싱으로 교체했다
    // (Figma SPy784gVofOiWCNGp8XWhp / 8003:2738 "2 자사몰 A안").
    { path: '/', name: 'home', component: () => import('@/views/MallHome2View.vue') },
    // 교체 전 메인(Figma 307:7171). 비교용으로 남겨 둔다.
    { path: '/v1', name: 'mall-home-v1', component: () => import('@/views/MallHomeV1View.vue') },
    // 그 전 화면. 확정되면 HomeView.vue 와 함께 지운다.
    { path: '/legacy', name: 'mall-home-legacy', component: HomeView },
    // 검수 때 쓰던 주소들. 링크가 남아 있을 수 있어 메인으로 넘긴다.
    { path: '/new', redirect: { name: 'home' } },
    { path: '/v2', redirect: { name: 'home' } },
    { path: '/login', name: 'login', component: () => import('@/views/LoginView.vue') },
    { path: '/login/sns/:providerType', name: 'sns-callback', component: () => import('@/views/SnsCallbackView.vue') },
    { path: '/signup', name: 'signup', component: () => import('@/views/SignupView.vue') },
    { path: '/signup/sns/terms', name: 'sns-signup-terms', component: () => import('@/views/SnsTermsSignupView.vue') },
    { path: '/products', name: 'products', component: () => import('@/views/ProductListView.vue') },
    { path: '/b2b/products', name: 'b2b-products', component: () => import('@/views/B2bProductListView.vue'), meta: { requiresAuth: true } },
    { path: '/b2b/order', name: 'b2b-order', component: () => import('@/views/B2bOrderView.vue'), meta: { requiresAuth: true } },
    { path: '/product-detail', name: 'product-detail', component: () => import('@/views/ProductDetailView.vue') },
    { path: '/cart', name: 'cart', component: () => import('@/views/CartView.vue') },
    { path: '/order', name: 'order', component: () => import('@/views/OrderView.vue'), meta: { requiresAuth: true } },
    // 온넥트 결제창이 끝나고 돌아오는 자리(returnUrl). 서버 설정 pg.onnect.return-url 과 같아야 한다
    { path: '/payment/onnect/return', name: 'payment-onnect-return', component: () => import('@/views/PaymentReturnView.vue'), meta: { requiresAuth: true } },
    { path: '/notice', name: 'notice', component: () => import('@/views/NoticeView.vue') },
    { path: '/event', name: 'event', component: () => import('@/views/EventView.vue') },
    { path: '/faq', name: 'faq', component: () => import('@/views/FaqView.vue') },
    { path: '/my/info', name: 'my-info', component: () => import('@/views/MyInfoView.vue'), meta: { requiresAuth: true } },
    { path: '/my/password', name: 'my-password', component: () => import('@/views/MyPasswordView.vue'), meta: { requiresAuth: true } },
    { path: '/my/orders', name: 'my-orders', component: () => import('@/views/MyOrdersView.vue'), meta: { requiresAuth: true } },
    { path: '/my/storage', name: 'my-storage', component: () => import('@/views/MyStorageView.vue'), meta: { requiresAuth: true } },
    { path: '/my/address', name: 'my-address', component: () => import('@/views/MyAddressView.vue'), meta: { requiresAuth: true } },
    { path: '/my/inquiries', name: 'my-inquiries', component: () => import('@/views/MyInquiriesView.vue'), meta: { requiresAuth: true } },
    { path: '/my/inquiries/new', name: 'my-inquiry-new', component: () => import('@/views/MyInquiryFormView.vue'), meta: { requiresAuth: true } },
    { path: '/my/inquiries/:inquiryCode/edit', name: 'my-inquiry-edit', component: () => import('@/views/MyInquiryFormView.vue'), meta: { requiresAuth: true } },
    { path: '/my/inquiries/:inquiryCode', name: 'my-inquiry-detail', component: () => import('@/views/MyInquiryDetailView.vue'), meta: { requiresAuth: true } },
    { path: '/privacy', name: 'privacy', component: () => import('@/views/PrivacyView.vue') },
    { path: '/terms', name: 'terms', component: () => import('@/views/TermsView.vue') },
    { path: '/third-party', name: 'third-party', component: () => import('@/views/ThirdPartyView.vue') },
  ],
})

router.beforeEach(to => {
  const authStore = useAuthStore()
  if (to.meta.requiresAuth && !authStore.isLoggedIn) {
    authStore.clearSession()
    return { path: '/login', query: { redirect: to.fullPath } }
  }
  return true
})

export default router
